import { Base } from '@/interfaces/Base'
import { ProductDetail } from '@/models/ProductDetail'
import { Attribute } from '@/interfaces/Attribute'
import { BaseCharm } from '@/interfaces/BaseCharm'

export class ProductMaster {
  id: number
  attributesCount!: number
  attributesKeys!: string[]
  isBase: boolean
  products!: ProductDetail[]

  constructor (base: Base | BaseCharm, isBase: boolean) {
    this.id = base.id

    this.isBase = isBase

    if (base.products.length > 0) {
      const selectedProduct = base.products[0]

      this.attributesCount = selectedProduct.attributes.length
      this.attributesKeys = [...new Set(selectedProduct.attributes.map(item => item.key))]
      this.products = []

      for (const product of base.products) {
        this.products.push(new ProductDetail(product, this.isBase, base.idPrestashop))
      }
    }
  }

  productDetailFor (key: string, id: number, otherKey?: string, otherId?: number): ProductDetail | null{
    for (const product of this.products) {
      if (product.attributes[key].id === id) {
        if ((otherKey && otherId && product.attributes[otherKey].id === otherId) ||
          (!otherKey && !otherKey)) {
          return product
        }
      }
    }

    return null
  }

  attributesFor (key: string, otherKey?: string, otherId?: number) {
    const attributes: Attribute[] = []

    for (const product of this.products) {
      if (!this.isInAttributes(product.attributes[key].id, attributes)) {
        let add = false
        if (otherKey && otherId) {
          add = product.attributes[otherKey].id === otherId
        } else {
          add = true
        }

        if (add) {
          attributes.push(product.attributes[key])
        }
      }
    }

    return attributes
  }

  private isInAttributes (id: number, attributes: Attribute[]): boolean {
    for (const attribute of attributes) {
      if (attribute.id === id) {
        return true
      }
    }
    return false
  }
}
